export default __webpack_public_path__ + "static/media/Ella.b23a1608.jpeg";